import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";

import { defaultReturn, makePayload, generateDefaultActions, subKeySaga, requestSaga, fillDictionary,
  callbackSaga } from "../utils/helpers";

import { AUTH_LOGIN_SUCCESS } from "./auth";
import { GET_PIPELINE_ACTIVE_DEAL_DETAILS, DEAL_FETCH_SUCCESS } from "./deal";

const initialState = {
  guests: [],
  guest: {},
  lastUpdatedGuestRelation: { guestId: null, groupIds: null },
  lastUpdatedGuest: null,
  myCompanysGuestMetrics: null,
  allPossibleGuestMetrics: null,
  invitedToCompanies: [],
  guestCompanyLandingInfo: null,
  guestPermission: [],
  relatedGuests: [], // /all guests related to the current user's contact
  activeGuest: {}
};

// FETCH_GUEST_COMPANY_LANDING_INFO
export const FETCH_GUEST_COMPANY_LANDING_INFO = generateDefaultActions("FETCH_GUEST_COMPANY_LANDING_INFO");
export const fetchGuestCompanyLandingInfo = payload => makePayload(FETCH_GUEST_COMPANY_LANDING_INFO.value, payload);
function* fetchGuestCompanyLandingInfoSaga(payload) {
  const url = "/fetchGuestCompanyLandingInfo";
  // let requestSaga = callbackSaga(payload.callback);
  yield requestSaga(FETCH_GUEST_COMPANY_LANDING_INFO, url, "POST", payload);
}

// CLEAR LANDING INFO STORE
export const CLEAR_LANDING_INFO = generateDefaultActions("CLEAR_LANDING_INFO");
export const clearGuestCompanyLandingInfo = payload => makePayload(CLEAR_LANDING_INFO.value, payload);
function* clearGuestCompanyLandingInfoSaga(paylaod) {}

// RESEND_GUEST_SETUP_EMAIL
export const RESEND_GUEST_SETUP_EMAIL = generateDefaultActions("RESEND_GUEST_SETUP_EMAIL");
export const resendGuestSetupEmail = payload => makePayload(RESEND_GUEST_SETUP_EMAIL.value, payload);
function* resendGuestSetupEmailSaga(payload) {
  const url = "/resendGuestSetupEmail";
  yield requestSaga(RESEND_GUEST_SETUP_EMAIL, url, "POST", payload);
}

// INVITE_GUEST_TO_TARGET_EMAIL
export const INVITE_GUEST_TO_TARGET_EMAIL = generateDefaultActions("INVITE_GUEST_TO_TARGET_EMAIL");
export const inviteGuestToTargetEmail = payload => makePayload(INVITE_GUEST_TO_TARGET_EMAIL.value, payload);
function* inviteGuestToTargetEmailSaga(payload) {
  const url = "/guestInvitationEmail";
  yield requestSaga(INVITE_GUEST_TO_TARGET_EMAIL, url, "POST", payload);
}
// REMOVE_GUEST_METRIC
export const REMOVE_GUEST_METRIC = generateDefaultActions("REMOVE_GUEST_METRIC");
export const removeGuestMetric = payload => makePayload(REMOVE_GUEST_METRIC.value, payload);
function* removeGuestMetricSaga(payload) {
  const url = "/removeGuestMetric";
  yield requestSaga(REMOVE_GUEST_METRIC, url, "POST", payload);
}

// ADD_GUEST_METRIC
export const ADD_GUEST_METRIC = generateDefaultActions("ADD_GUEST_METRIC");
export const addGuestMetric = payload => makePayload(ADD_GUEST_METRIC.value, payload);
function* addGuestMetricSaga(payload) {
  const url = "/addGuestMetric";
  yield requestSaga(ADD_GUEST_METRIC, url, "POST", payload);
}

// GET_MY_COMPANYS_GUEST_METRICS
export const GET_MY_COMPANYS_GUEST_METRICS = generateDefaultActions("GET_MY_COMPANYS_GUEST_METRICS");
export const getMyCompanysGuestMetrics = payload => makePayload(GET_MY_COMPANYS_GUEST_METRICS.value, payload);
function* getMyCompanysGuestMetricsSaga(payload) {
  const url = "/getMyCompanysGuestMetrics";
  yield requestSaga(GET_MY_COMPANYS_GUEST_METRICS, url);
}

// GET_ALL_POSSIBLE_GUEST_METRICS
export const GET_ALL_POSSIBLE_GUEST_METRICS = generateDefaultActions("GET_ALL_POSSIBLE_GUEST_METRICS");
export const getAllPossibleGuestMetrics = payload => makePayload(GET_ALL_POSSIBLE_GUEST_METRICS.value, payload);
function* getAllPossibleGuestMetricsSaga(payload) {
  const url = "/getAllPossibleGuestMetrics";
  yield requestSaga(GET_ALL_POSSIBLE_GUEST_METRICS, url);
}

// UPDATE_GROUPS_OF_GUEST
export const UPDATE_GROUPS_OF_GUEST = generateDefaultActions("UPDATE_GROUPS_OF_GUEST");
export const updateGroupsOfGuest = payload => makePayload(UPDATE_GROUPS_OF_GUEST.value, payload);
function* updateGroupsOfGuestSaga(payload) {
  const url = "/updateGuestGroupsOfGuest";
  yield requestSaga(UPDATE_GROUPS_OF_GUEST, url, "POST", payload);
}

// GET_GUEST_BY_ID
export const GET_GUEST_BY_ID = generateDefaultActions("GET_GUEST_BY_ID");
export const getGuestById = payload => makePayload(GET_GUEST_BY_ID.value, payload);
function* getGuestByIdSaga(payload) {
  const { includeAuxData, id } = payload;
  yield requestSaga(GET_GUEST_BY_ID, `/guest?includeAuxData=${includeAuxData}&id=${id}`);
}

// GET_GUEST_BY_DEALID
export const GET_GUEST_BY_DEALID = generateDefaultActions("GET_GUEST_BY_DEALID");
export const getGuestsByDealId = payload => makePayload(GET_GUEST_BY_DEALID.value, payload);
function* getGuestsByDealIdSaga(payload) {
  const { dealId, accessTypeId } = payload;
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(GET_GUEST_BY_DEALID, `/guest/deal?dealId=${dealId}&accessTypeId=${accessTypeId}`);
}

// ADD_GUESTS_TO_DEAL
export const ADD_GUESTS_TO_DEAL = generateDefaultActions("ADD_GUESTS_TO_DEAL");
export const addGuestsToDeal = payload => makePayload(ADD_GUESTS_TO_DEAL.value, payload);
function* addGuestsToDealSaga(payload) {
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(ADD_GUESTS_TO_DEAL, "/guest/deal", "POST", payload);
}

// DELETE_GUEST_BY_DEALID
export const DELETE_GUEST_BY_DEALID = generateDefaultActions("DELETE_GUEST_BY_DEALID");
export const deleteGuestsByDealId = payload => makePayload(DELETE_GUEST_BY_DEALID.value, payload);
function* deleteGuestsByDealIdSaga(payload) {
  const { includeAuxData, id, dealId, accessTypeId } = payload;
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(DELETE_GUEST_BY_DEALID, `/guest/deal?includeAuxData=${includeAuxData}&id=${id}&dealId=${dealId}&accessTypeId=${accessTypeId}`, "DELETE");
}

// GET_ALL_GUESTS
export const GET_ALL_GUESTS = generateDefaultActions("GET_ALL_GUESTS");
export const getAllGuests = payload => makePayload(GET_ALL_GUESTS.value, payload);
function* getAllGuestsSaga(payload) {
  const { includeAuxData } = payload;
  yield requestSaga(GET_ALL_GUESTS, `/guest?includeAuxData=${includeAuxData}`);
}

// DELETE_GUEST_BY_ID
export const DELETE_GUEST_BY_ID = generateDefaultActions("DELETE_GUEST_BY_ID");
export const deleteGuestById = payload => makePayload(DELETE_GUEST_BY_ID.value, payload);
function* deleteGuestByIdSaga(payload) {
  yield requestSaga(DELETE_GUEST_BY_ID, `/guest?guestId=${payload.guestId}`, "DELETE");
}

// ADD_GUEST_TO_DEALS
export const ADD_GUEST_TO_DEALS = generateDefaultActions("ADD_GUEST_TO_DEALS");
export const addGuestToDeals = payload => makePayload(ADD_GUEST_TO_DEALS.value, payload);
function* getAddGuestToDealsSaga(payload) {
  const url = "/addGuestToDeals";
  yield requestSaga(ADD_GUEST_TO_DEALS, url, "POST", payload);
}

// REMOVE_GUEST_FROM_DEALS
export const REMOVE_GUEST_FROM_DEALS = generateDefaultActions("REMOVE_GUEST_FROM_DEALS");
export const removeGuestFromDeals = payload => makePayload(REMOVE_GUEST_FROM_DEALS.value, payload);
function* getRemoveGuestFromDealsSaga(payload) {
  const url = "/removeGuestFromDeals";
  yield requestSaga(REMOVE_GUEST_FROM_DEALS, url, "POST", payload);
}

// ADD_GUEST_TO_FUNDS
export const ADD_GUEST_TO_FUNDS = generateDefaultActions("ADD_GUEST_TO_FUNDS");
export const addGuestToFunds = payload => makePayload(ADD_GUEST_TO_FUNDS.value, payload);
function* getAddGuestToFundsSaga(payload) {
  const url = "/addGuestToFunds";
  yield requestSaga(ADD_GUEST_TO_FUNDS, url, "POST", payload);
}

// REMOVE_GUEST_FROM_FUNDS
export const REMOVE_GUEST_FROM_FUNDS = generateDefaultActions("REMOVE_GUEST_FROM_FUNDS");
export const removeGuestFromFunds = payload => makePayload(REMOVE_GUEST_FROM_FUNDS.value, payload);
function* getRemoveGuestFromFundsSaga(payload) {
  const url = "/removeGuestFromFunds";
  yield requestSaga(REMOVE_GUEST_FROM_FUNDS, url, "POST", payload);
}

// SET_GUEST_ACCESS_TO_ALL_ITEMS
export const SET_GUEST_ACCESS_TO_ALL_ITEMS = generateDefaultActions("SET_GUEST_ACCESS_TO_ALL_ITEMS");
export const setGuestAccessToAllItems = payload => makePayload(SET_GUEST_ACCESS_TO_ALL_ITEMS.value, payload);
function* getSetGuestAccessToAllItemsSaga(payload) {
  const url = "/setGuestAccessToAllItems";
  yield requestSaga(SET_GUEST_ACCESS_TO_ALL_ITEMS, url, "POST", payload);
}

// UPDATE_GUEST_PERMISSIONS
export const UPDATE_GUEST_PERMISSIONS = generateDefaultActions("UPDATE_GUEST_PERMISSIONS");
export const updateGuestPermissions = payload => makePayload(UPDATE_GUEST_PERMISSIONS.value, payload);
function* updateGuestPermissionsSaga(payload) {
  const url = "/updateGuestPermissions";
  yield requestSaga(UPDATE_GUEST_PERMISSIONS, url, "POST", payload);
}

// GET_INVITED_TO_COMPANIES
export const GET_INVITED_TO_COMPANIES = generateDefaultActions("GET_INVITED_TO_COMPANIES");
export const getInvitedToCompanies = payload => makePayload(GET_INVITED_TO_COMPANIES.value, payload);
function* getInvitedToCompaniesSaga(payload) {
  const { id } = payload;
  yield requestSaga(GET_INVITED_TO_COMPANIES, `/guest/getInvitedToCompanies?id=${id}`);
}

export default function guestReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  let activeGuest = {};
  switch (type) {
    case AUTH_LOGIN_SUCCESS:
      let relatedGuests = [];
      try {
        relatedGuests = payload.user.contact.guests;
      } catch (e) {}

      return {
        ...state,
        relatedGuests
      };
    case DEAL_FETCH_SUCCESS:
      activeGuest = {};
      try {
        // this should work because collab groups are filted out serverside
        activeGuest = state.relatedGuests.filter(x => x.companyId == payload.deal.funds[0].companyId)[0];
      } catch (e) {}

      return {
        ...state,
        activeGuest
      };
    case GET_PIPELINE_ACTIVE_DEAL_DETAILS.success:
      activeGuest = {};
      try {
        activeGuest = state.relatedGuests.filter(x => x.companyId == payload.data.funds[0].companyId)[0];
      } catch (e) {}

      return {
        ...state,
        activeGuest
      };
    case CLEAR_LANDING_INFO.value:
      return { ...state, guestCompanyLandingInfo: null };
    case FETCH_GUEST_COMPANY_LANDING_INFO.success:
      // delete payload.result.deals.__dataRedacterIgnore__;
      activeGuest = {};
      try {
        activeGuest = state.relatedGuests.filter(x => x.companyId == payload.viewingCompany)[0];
      } catch (e) {}

      return {
        ...state,
        guestCompanyLandingInfo: payload.result,
        landingToken: payload.landingToken,
        activeGuest
      };
    case ADD_GUEST_METRIC.success:
    case REMOVE_GUEST_METRIC.success:
      return defaultReturn(state, payload.newList, "myCompanysGuestMetrics");
    case RESEND_GUEST_SETUP_EMAIL.success:
      ToastSuccess("Invite Success");
      break;
    case RESEND_GUEST_SETUP_EMAIL.failure:
      ToastError("Network Error. Invite not sent");
      break;
    case GET_ALL_POSSIBLE_GUEST_METRICS.success:
      return defaultReturn(state, payload.result, "allPossibleGuestMetrics");
    case GET_MY_COMPANYS_GUEST_METRICS.success:
      return defaultReturn(state, payload.result, "myCompanysGuestMetrics");
    case UPDATE_GUEST_PERMISSIONS.success:
      return defaultReturn(state, payload.response, "lastUpdatedGuest");
    case UPDATE_GROUPS_OF_GUEST.success:
      return defaultReturn(state, { guestId: payload.guestId, groupIds: payload.groupIds }, "lastUpdatedGuestRelation");
    case GET_ALL_GUESTS.success:
      return defaultReturn(state, payload.response, "guests");
    case GET_GUEST_BY_ID.success:
      return defaultReturn(state, payload.response, "guest");

    case ADD_GUEST_TO_DEALS.success:
    case REMOVE_GUEST_FROM_DEALS.success:
    case ADD_GUEST_TO_FUNDS.success:
    case REMOVE_GUEST_FROM_FUNDS.success:
    case SET_GUEST_ACCESS_TO_ALL_ITEMS.success:
      return defaultReturn(state, payload.response, "guest");

    case GET_GUEST_BY_DEALID.success:
    case ADD_GUESTS_TO_DEAL.success:
    case DELETE_GUEST_BY_DEALID.success:
      return fillDictionary(state, payload.response, "dealguests", subKey);
    case DELETE_GUEST_BY_ID.success:
      ToastSuccess("Guest Deleted");

      return defaultReturn(state, payload.response, "guests");
    case DELETE_GUEST_BY_ID.failure:
      ToastError("Error Deleting Guest");
      break;
    case GET_INVITED_TO_COMPANIES.success:
      return defaultReturn(state, payload.response, "invitedToCompanies");
    default:
      if (payload && payload.guestPermission) {
        return defaultReturn(state, payload.guestPermission, "guestPermission");
      }

      return state;
  }
}

export function* guestSaga() {
  yield takeLatest(ADD_GUEST_TO_DEALS.value, getAddGuestToDealsSaga);
  yield takeLatest(REMOVE_GUEST_FROM_DEALS.value, getRemoveGuestFromDealsSaga);
  yield takeLatest(ADD_GUEST_TO_FUNDS.value, getAddGuestToFundsSaga);
  yield takeLatest(REMOVE_GUEST_FROM_FUNDS.value, getRemoveGuestFromFundsSaga);
  yield takeLatest(SET_GUEST_ACCESS_TO_ALL_ITEMS.value, getSetGuestAccessToAllItemsSaga);
  yield takeLatest(GET_ALL_GUESTS.value, getAllGuestsSaga);
  yield takeLatest(GET_GUEST_BY_ID.value, getGuestByIdSaga);
  yield takeLatest(DELETE_GUEST_BY_ID.value, deleteGuestByIdSaga);
  yield takeLatest(GET_GUEST_BY_DEALID.value, getGuestsByDealIdSaga);
  yield takeLatest(UPDATE_GROUPS_OF_GUEST.value, updateGroupsOfGuestSaga);
  yield takeLatest(UPDATE_GUEST_PERMISSIONS.value, updateGuestPermissionsSaga);
  yield takeLatest(DELETE_GUEST_BY_DEALID.value, deleteGuestsByDealIdSaga);
  yield takeLatest(ADD_GUESTS_TO_DEAL.value, addGuestsToDealSaga);
  yield takeLatest(GET_ALL_POSSIBLE_GUEST_METRICS.value, getAllPossibleGuestMetricsSaga);
  yield takeLatest(GET_MY_COMPANYS_GUEST_METRICS.value, getMyCompanysGuestMetricsSaga);
  yield takeLatest(ADD_GUEST_METRIC.value, addGuestMetricSaga);
  yield takeLatest(REMOVE_GUEST_METRIC.value, removeGuestMetricSaga);
  yield takeLatest(GET_INVITED_TO_COMPANIES.value, getInvitedToCompaniesSaga);
  yield takeEvery(INVITE_GUEST_TO_TARGET_EMAIL.value, inviteGuestToTargetEmailSaga);
  yield takeLatest(RESEND_GUEST_SETUP_EMAIL.value, resendGuestSetupEmailSaga);
  yield takeLatest(FETCH_GUEST_COMPANY_LANDING_INFO.value, fetchGuestCompanyLandingInfoSaga);
  yield takeEvery(CLEAR_LANDING_INFO.value, clearGuestCompanyLandingInfoSaga);
}
